<template>
    <div class="ElSelectOptions">
      <el-option
        v-for="o in item.options||ajaxOptions"
        :key="o[item.key]"
        :label="o[item.label]"
        :value="o[item.key]"
        :disabled="o[item.disabled]"
      >
      </el-option>
    </div>

</template>

<script>
export default {
  name: 'ElSelectOptions',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      ajaxOptions: []
    }
  },
  methods: {
    loadAjaxOptions: async function () {
      const that = this
      const { url, para } = that.item
      if (url) {
        const { data: res } = await that.$http.post(url, para)
        that.ajaxOptions = res.data
      }
    }
  },
  created () {
    this.loadAjaxOptions()
  }
}
</script>

<style lang="less" scoped>

</style>
